import UnauthorizedPage from "@/components/pages/UnauthorizedPage";
import useIsMyDiary from "@/features/patients/hooks/useIsMyDiary";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId")({
    component: EntryLayout,
});

function EntryLayout() {
    const { diaryId } = Route.useParams();
    const { isMyDiary } = useIsMyDiary(diaryId);

    // Block staff from filling patient forms; allow while ownership is still resolving.
    if (isMyDiary === false) {
        return <UnauthorizedPage message="As this is not your diary you cannot add entries." />;
    }

    return <Outlet />;
}
